import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Col as Col$1 } from 'react-bootstrap';
import { createResponsiveClasses } from '../utils/create-responsive-classes/create-responsive-classes.esm.js';

const Col = /*#__PURE__*/ forwardRef(({ span, offset, spacingGroup, className, ...rest }, ref)=>{
    return jsx(Col$1, {
        ...rest,
        className: classNames(spacingGroup, className, createResponsiveClasses({
            bsPrefix: 'col',
            responsiveDefinitition: span
        }), createResponsiveClasses({
            bsPrefix: 'offset',
            responsiveDefinitition: offset
        })),
        ref: ref
    });
});

export { Col };
